<!--
 * @Author: your name
 * @Date: 2021-01-04 15:43:32
 * @LastEditTime: 2021-02-03 14:12:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\ExamineDialog.vue
-->
<template>
  <div id='examine'>
    <el-dialog title="审批拒绝" :visible.sync="applyVisible" width="25%" custom-class="addInfoVisible" @close="closeApplyDialog">
      <el-row>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">拒绝原因:</el-col>
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <el-input type="textarea" v-model="reasonPrams.comment" placeholder="请填写拒绝原因"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="isSuccess(4)">确 定</span>
        <span class="button" type="primary" @click="applyVisible=false">取 消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { applyRecord } from '@/api/index'
export default {
  data() {
    return {
      applyVisible: false,
      reasonPrams: {
        id: '',
        applyStatus: '',
        comment: ''
      },
    }
  },
  created() {
    
  },
  methods: {
    //审批
    async isSuccess(status) {
      this.reasonPrams.id = this.$parent.quesNaireData ? this.$parent.quesNaireData.id : ''
      this.reasonPrams.applyStatus = status
      const { data } = await applyRecord(this.reasonPrams)
      if (data.code != 0) return
      this.$parent.$parent.tabIndex = 0
      this.$parent.$parent.findAllTask()
    },
    closeApplyDialog() {
      this.reasonPrams.comment = ''
    },
  }
}
</script>
<style lang='less' scoped>
</style>
